import { useEffect, useState } from 'react';
import { getTotalAppliedCandidatesBySource } from 'wisestep-api';

import CumulativeMatricValuesChart from '../../../components/CumulativeMatricValuesChart/CumulativeMatricValuesChart';
import { IAggregation } from '../../../types';
import { IMISAnalyticsQuery } from '../../IMISAnalyticsQuery';

const TotalAppliedCandidatesBySource = ({ query }: IMISAnalyticsQuery) => {
  const [aggregatedData, setAggregatedData] = useState<IAggregation[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getTotalAppliedCandidatesBySource(query);
      response.data.aggregations.aggregation.buckets.push({
        doc_count: response.data.hits.total,
        key: 'Total',
      });
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [query]);

  return (
    <CumulativeMatricValuesChart
      data={aggregatedData}
      title="Total candidates applied by source - Life Time"
    />
  );
};

export default TotalAppliedCandidatesBySource;
